module.exports = __webpack_public_path__ + "images/DPB2_1.38e97e1da6d800e645e58d96e9c94682.png";